import { render, staticRenderFns } from "./player_data_detail.vue?vue&type=template&id=4142366e&scoped=true"
import script from "./player_data_detail.vue?vue&type=script&lang=js"
export * from "./player_data_detail.vue?vue&type=script&lang=js"
import style0 from "./player_data_detail.vue?vue&type=style&index=0&id=4142366e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4142366e",
  null
  
)

export default component.exports